import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

// Services
import { GerinusBD } from 'src/app/app-core/lib/gerinus-bd.component';
import { GlobalService } from 'src/app/app-core/lib/global.service';
import { RequestService } from 'src/app/app-core/services/request.service';
import { DepartmentService } from 'src/app/app-core/services/department.service';
import { RequestCorrectionService } from 'src/app/app-core/services/requestCorrection.service';
import { ProcessService } from 'src/app/app-core/services/process.service';
import { UserService } from 'src/app/app-core/services/user.service';
import { CryptoService } from 'src/app/app-core/services/crypto.service';

// External Libraries
import Swal from 'sweetalert2';
import $ from 'jquery';
import 'bootstrap/dist/js/bootstrap.bundle';
import * as moment from 'moment';

// Interfaces
import { ICancelRequestSchema, Request } from 'src/app/interfaces/request';
import { IDepartment } from 'src/app/interfaces/department';
import { IListScopeDepartmentResponse } from 'src/app/interfaces/listScope/listScopeDepartmentResponse';
import { IGetEntityRequestResponse } from 'src/app/interfaces/getEntity/getEntityRequestResponse';
import { IListScopeRequestCorrectionResponse } from 'src/app/interfaces/listScope/listScopeRequestCorrectionResponse';
import { IRequestCorrection } from 'src/app/interfaces/requestCorrection';
import { IGetEntityRequestCorrectionResponse } from 'src/app/interfaces/getEntity/getEntityRequestCorrectionResponse';
import { MessageService } from 'primeng/api';
import { ReturnRequestTypeService } from 'src/app/app-core/services/return-request-type.service';
import { SubjectService } from 'src/app/app-core/services/subject.service';
import { ISubject } from 'src/app/interfaces/subject';

//Enum
import { RequestStatusEnum } from 'src/app/Enums/RequestStatusEnum';
import { UploadService } from 'src/app/app-core/services/upload.service';
import { id } from 'date-fns/locale';
import { RequestAttachmentService } from 'src/app/app-core/services/requestAttachment.service';
import { requestAttachmentStatusEnum } from 'src/app/Enums/request.enum';
import { HttpEvent, HttpEventType } from '@angular/common/http';
import { GlobalStateService } from 'src/app/app-core/services/global-state.service';
import { RequestHistoryService } from 'src/app/app-core/services/requestHistory.service';
import { OrganizationEnum } from 'src/app/Enums/organizationEnum';

enum keysDocumentosEnum {
    COMPLEMENTAR = 'complementar',
    PROCURACAO = 'procuracao',
    REQUERIMENTO = 'requerimento',
}

@Component({
    selector: 'app-view-correction-requests',
    templateUrl: './view-correction-requests.component.html',
    styleUrls: ['./view-correction-requests.component.scss'],
    providers: [
        RequestService,
        RequestHistoryService,
        DepartmentService,
        GlobalService,
        RequestCorrectionService,
        ReturnRequestTypeService,
        ProcessService,
        UserService,
        MessageService,
        RequestAttachmentService,
        SubjectService,
    ],
})
export class ViewCorrectionRequestsComponent extends GerinusBD implements OnInit, AfterViewInit {
    public listReturnRequestType = [];
    public type: string;
    public selectedType: string = '';
    public mimeTypes: string[] = ['application/pdf'];
    public request: Request;
    public showCorrectionInfo: boolean = false;
    public departments: IDepartment[] = [];
    public modalName: string = 'solicitacao-actions';
    public requestCorrections: IRequestCorrection[] = [];
    public lastDescription: any;
    public swal = Swal;
    public process = {
        department: '',
        PRC_CodigoSolicitacao: 0,
        SOL_Autorizante: 0,
        PRCH_Historico: '',
        PRC_DataRecebimento: new Date(this.global.currentDate.setHours(this.global.currentDate.getHours() - 3)),
        NTR_Descricao: '',
        NTR_Autor: null,
    };
    public hasUserUploadedFile: boolean = false;
    public reasonCancel: string;

    public proccessNumber: string;
    public correctionData: Date;
    public requestId: string;
    public customRequest: string;

    public documentCloudflareUrl: string;
    public textAreaDisabled: boolean = true;
    public selectedReason: string = '';
    public selectedCancellation = '';

    typeRequestReturn = [
        { value: 'DocumentacaoCorrompida', label: 'Documentação Corrompida' },
        { value: 'DocumentacaoIncompleta', label: 'Documentação Incompleta' },
        { value: 'AssinaturaResponsavelIncompleta', label: 'A assinatura do responsável não está devidamente preenchida' },
        { value: 'RequerimentoIncompleto', label: 'O requerimento do formulário está incompleto' },
        { value: 'AusenciaProcuracoes', label: 'Ausência de Procurações' },
        { value: 'Outros', label: 'Outros' }
    ]

    isDescriptionDisabled: boolean = false;

    public alreadyFilteredList = {}

    public reasons = [
        { value: 'Preenchimento Incorreto do Assunto', label: 'Preenchimento incorreto do assunto' },
        { value: 'Documentação Insuficiente', label: 'Documentação insuficiente' },
        { value: 'Verificar Situação com o Órgão', label: 'Verificar situação com o Órgão' },
        { value: 'Múltiplas Solicitações/Processo', label: 'Múltiplas solicitações/processo' },
        { value: 'Criação de Solicitação de Empresa por Pessoa Física', label: 'Criação de solicitação de empresa por pessoa física' }
    ];

    public reasonMessage: string = 'Prezado Contribuinte. Após um processo de análise, sua solicitação será anulada. A equipe de triagem observou e encontrou empecilhos que incapacitaram o andamento da solicitação. Foi detectado o seguinte problema:'
    public groupedDocuments: { [tipo: string]: any[] } = {};
    public uniqueDocumentTypes: string[] = [];
    public checkingDocuments = false;
    public isLoading: boolean = false;
    public isTableHistoryOpen: boolean[] = [];
    public historics: any[] = [];
    public currentCorrectionConsiderations: string = '';
    public lastPendingCorrection: IRequestCorrection;
    public allExpanded = false;

    public subjects: ISubject[] = [];
    public subjectSearch: string = '';
    public selectedSubjectCode: number = null;
    public selectedSubjectDescricao: string = '';


    constructor(
        public global: GlobalService,
        public route: ActivatedRoute,
        private router: Router,
        public requestService: RequestService,
        public departmentService: DepartmentService,
        public correctionService: RequestCorrectionService,
        public returnRequestTypeService: ReturnRequestTypeService,
        public proccessService: ProcessService,
        public userService: UserService,
        private cryptoService: CryptoService,
        private uploadService: UploadService,
        private cd: ChangeDetectorRef,
        private requestAttachmentService: RequestAttachmentService,
        private globalStateService: GlobalStateService,
        private historicService: RequestHistoryService,
        private subjectService: SubjectService,
    ) {
        super(global, requestService);
        this.showEmptyData = false;
        this.showHeader = false;
        this.showPaginate = false;
        this.afterCreate();

        this.route.params.subscribe(() => {
            const params = this.route.snapshot.paramMap;
            this.type = params.get('type') || this.route.snapshot.url[0]?.path;

            try {
                this.requestId = this.cryptoService.decrypt(String(params.get('id')));
                if (!this.requestId) {
                    this.handleRedirect();
                }
                this.getRequest(parseInt(this.requestId));
            } catch (error) {
                this.handleRedirect();
            }
        });

        this.add();
        this.getListReturnRequestType();
    }

    ngOnInit(): void {
        const title = document.querySelector('title');

        title.text = 'Visualização da Solicitação';
        this.getLastCorrection(parseInt(this.requestId));

        this.customRequest = this.userService.isCidadao()
            ? 'mt-4 mt-md-5 mt-lg-4'
            : 'mt-4 mt-md-8 mt-lg-8';
        this.updateDescription();
    }

    ngAfterViewInit(): void {
        this.cd.detectChanges();
    }

    public defaults() {
        return {
            correctionInfoUser: {
                isCidadao: true,
                idField: 0,
                SOLC_DataCorrecao: new Date(this.global.currentDate.setHours(this.global.currentDate.getHours() - 3)),
                SOLC_Status: 1,
                SOL_Status: 0,
                SOLH_Historico: 'A solicitação foi reenviada para análise.',
            },
            documentos: {
                procuracao: [],
                requerimento: [],
                complementar: [],
            },
            correctionInfo: {
                idField: '',
                SOLH_Historico: 'A solicitação foi movida para correção de pendencias',
                SOLC_Status: 0,
                SOLC_DataLimiteCorrecao: moment(),
                SOL_Status: 2,
                SOLC_Descricao: null,
            },
        };
    }

    private handleRedirect(): void {

        this.router.navigate([`/requests/${this.userService.isTriagem() ? 'evaluation' : 'ongoing'}`], { queryParams: { 'not-found': true } });
    }

    getListReturnRequestType() {
        this.returnRequestTypeService.listAll(null, 0).subscribe({
            next: (response: any) => {
                this.listReturnRequestType = response.data
            }
        });
    }

    getLastCorrection(requestId: number) {
        this.correctionService.listAll(`"SOLC_CodigoSolicitacao" = ${requestId}`).subscribe({
            next: (response: IListScopeRequestCorrectionResponse) => {
                this.requestCorrections = response.data;

                this.requestCorrections.sort((a, b) => {
                    const dateA = new Date(a.created_at).getTime();
                    const dateB = new Date(b.created_at).getTime();
                    return dateB - dateA;
                });

                this.lastDescription = this.requestCorrections[0];

                this.lastPendingCorrection = this.requestCorrections.find(correction =>
                    !correction.SOLC_DataCorrecao
                );

                if (this.lastPendingCorrection?.SOLC_RetornoCidadao) {
                    this.currentCorrectionConsiderations = this.lastPendingCorrection.SOLC_RetornoCidadao;
                }
            },
            error: (error) => {
                console.error('Erro ao carregar correções:', error);
            }
        });
    }

    getRequest(requestId: number) {
        this.requestService.getEntity(requestId).subscribe({
            next: (response: IGetEntityRequestResponse) => {
                this.request = response.entity;
                this.uploadService.download(this.request.DOC_Conteudo, 'SIGN').subscribe({
                    next: (response: any) => {
                        this.documentCloudflareUrl = response.url;
                    }
                })
                this.groupDocumentsByType();
                this.checkRequestRouter(this.request);
                this.departmentService.listAll(`"DEP_CodigoOrgao" = ${this.request.SOL_CodigoOrgao}`, 0).subscribe({
                    next: (response: IListScopeDepartmentResponse) => {
                        this.departments = response.data.filter(dep =>
                            dep.DEP_TipoProcessoAceito === 1 || dep.DEP_TipoProcessoAceito === 3
                        );

                        const subjectDepartment = this.request.AS_CodigoDepartamento;

                        if (subjectDepartment) {
                            this.process.department = String(subjectDepartment);
                        }
                    },
                });
            },
        });

        return this.request;
    }

    checkRequestRouter(request: Request) {
        if (this.type === 'edit' && request.SOL_Status == 0) {
            this.type = 'view';

            this.global.router.navigate([`/requests/${this.type}/${this.request.SOL_CodigoSolicitacao}`]);
        }
    }

    public save() {
        this.entity.correctionInfo.SOLC_CodigoSolicitacao = this.request.SOL_CodigoSolicitacao;
        this.entity.correctionInfo.idField = 0;
        this.entity.correctionInfo.SOLC_DataLimiteCorrecao = moment()
            .add(this.request.AS_PrazoCorrecao, 'days')
            .format('YYYY-MM-DD HH:mm:ss');

        this.entity.correctionInfo.PE_CodigoPessoa = this.global.user().PE_CodigoPessoa;

        this.global.startLoading('Processando...', true);
        this.correctionService.save(this.entity.correctionInfo).subscribe({
            next: (response: IGetEntityRequestCorrectionResponse) => {
                this.global.stopLoading();
                this.correctionData = new Date(response.entity.created_at);
                this.global.showModalInfo(`${this.modalName}-send-correction`);
            },
        });
    }

    scrollBottom() {
        $('html, body').animate(
            {
                scrollTop: $(document).height(),
            },
            1000,
        );
    }

    public getUploadedFile(event: any, attachment = null) {
        let file = event.file;

        if (
            file.typeDocument != keysDocumentosEnum.PROCURACAO &&
            file.typeDocument != keysDocumentosEnum.COMPLEMENTAR
        ) {
            file = {
                ...file,
                ANX_Obrigatorio: attachment.ANX_Obrigatorio,
            };
            this.entity.documentos[keysDocumentosEnum.REQUERIMENTO].push(file);
        } else {
            this.entity.documentos[file.typeDocument].push(file);
        }

        this.hasUserUploadedFile = true;
    }

    sendCorrection() {
        this.checkingDocuments = true;
        let isAllDocumentsValid = true;
        let missingDocument = '';

        const documentosAnexadosParaACorrecao = [
            ...this.entity.documentos[keysDocumentosEnum.REQUERIMENTO],
            ...this.entity.documentos[keysDocumentosEnum.PROCURACAO],
        ];

        this.requestAttachmentService.listAll(`"SOLA_CodigoSolicitaco" = ${this.requestId}`).subscribe({
            next: (response: any) => {
                const documentos = response.data;

                for (const tipo of this.uniqueDocumentTypes) {
                    const documentosPorTipo = documentos.filter(documento => documento.SOLA_Tipo === tipo);
                    const quantidadeDeDocumentosAnulados = documentosPorTipo.filter(documento => documento.SOLA_Status === requestAttachmentStatusEnum.ANULADO);

                    if (documentosPorTipo.length !== 0 && documentosPorTipo.length === quantidadeDeDocumentosAnulados.length) {
                        const documentosAnexadoPorTipo = documentosAnexadosParaACorrecao.filter(documento => documento.typeDocument === tipo);

                        if (documentosAnexadoPorTipo.length === 0) {
                            isAllDocumentsValid = false;
                            missingDocument = tipo;
                            break;
                        }
                    }
                }

                this.checkingDocuments = false;

                if (isAllDocumentsValid) {
                    const pendingCorrections = this.requestCorrections.filter(c => !c.SOLC_DataCorrecao);

                    if (pendingCorrections.length === 0) {
                        Swal.fire('Atenção', 'Não há correções pendentes para enviar.', 'info');
                        return;
                    }

                    this.global.startLoading('Processando...', true);

                    pendingCorrections.forEach((correction, index) => {
                        const payload = {
                            ...this.entity.correctionInfoUser,
                            SOLC_CodigoSolicitacao: this.request.SOL_CodigoSolicitacao,
                            idField: correction.SOLC_CodigoCorrecao,
                            PE_CodigoPessoa: this.global.user().PE_CodigoPessoa,
                            SOLC_DataCorrecao: new Date(),
                            SOL_Status: RequestStatusEnum.corrected,
                            documentos: this.entity.documentos
                        };

                        this.correctionService.save(payload).subscribe({
                            next: () => {
                                if (index === pendingCorrections.length - 1) {
                                    this.global.stopLoading();
                                    if (this.userService.isCidadao()) {
                                        this.global.router.navigate(['/citizen']);
                                    } else {
                                        this.global.router.navigate(['/requests/ongoing']);
                                    }
                                }
                            },
                            error: (err) => {
                                this.global.stopLoading();
                                Swal.fire('Erro', 'Não foi possível enviar a correção.', 'error');
                                console.error('Erro ao enviar correção:', err);
                            }
                        });
                    });
                } else {
                    Swal.fire({
                        title: 'Atenção',
                        text: `Você deve informar um documento de ${missingDocument} válido!`,
                        icon: 'warning',
                        showCancelButton: true,
                        cancelButtonColor: '#417bff',
                        cancelButtonText: 'OK',
                        showConfirmButton: false,
                    });
                }
            }
        });
    }

    async saveProcess() {
        this.process.PRC_CodigoSolicitacao = this.request.SOL_CodigoSolicitacao;
        this.process.PRCH_Historico = 'O processo foi criado';
        this.global.startLoading('Processando...', true);
        this.process.SOL_Autorizante = this.global.user().USR_CodigoUsuario;
        this.process.NTR_Autor = this.global.user().PE_CodigoPessoa;

        this.proccessService.save(this.process).subscribe({
            next: async () => {
                this.global.stopLoading();
                this.global.router.navigate(['/process/all']);
                this.global.closeModalInfo(this.modalName);
            },
        });
    }

    public onDeleteFileUploaded(event: any) {
        if (
            event.typeDocument != keysDocumentosEnum.COMPLEMENTAR &&
            event.typeDocument != keysDocumentosEnum.PROCURACAO
        ) {
            this.entity.documentos[keysDocumentosEnum.REQUERIMENTO].splice(
                this.entity.documentos[keysDocumentosEnum.REQUERIMENTO].length - 1,
                1,
            );
        } else {
            this.entity.documentos[event.typeDocument].splice(this.entity.documentos[event.typeDocument].length - 1, 1);
        }

        this.checkDocuments();
    }

    private checkDocuments() {
        const updatedRequest = this.getRequest(this.request.SOL_CodigoSolicitacao);

        if (this.entity.documentos.requerimento.length === 0) {
            this.hasUserUploadedFile = false;
        }

        for (const document of updatedRequest.documentos[keysDocumentosEnum.REQUERIMENTO]) {
            if (document.SOLA_Status == 0) {
                this.hasUserUploadedFile = false;
            }
        }

        for (const document of updatedRequest.documentos[keysDocumentosEnum.PROCURACAO]) {
            if (document.SOLA_Status == 0 &&
                Object.keys(this.entity.documentos.procuracao).length === 0 &&
                this.request.SOLR_CpfCnpj != '') {
                this.hasUserUploadedFile = false;
            }
        }
    }

    filterDocumentByType(type: string) {
        const list = this.request.documentos.requerimento.filter((document) => document.SOLA_Tipo === type);
        return list;
    }

    public showModalCorrectionDetails() {
        this.global.showModalInfo('correction-details');
    }

    public isIPTU(): boolean {
        return this.request.TAG_Nome == 'IPTU' ? true : false;
    }

    openPdfRequest(): void {
        this.global.showModalInfo('documents')
    }

    showModalCancelRequest() {
        this.global.showModalInfo('cancel-request');
    }

    handleCancelRequest() {
        this.global.closeModalInfo('cancel-request');

        const fullReason = this.selectedCancellation === 'outros'
            ? `${this.reasonCancel}`
            : `${this.reasonMessage} ${this.selectedCancellation}`

        const cancelRequestData: ICancelRequestSchema = {
            requestId: Number(this.requestId),
            reasonCancel: fullReason,
            userId: this.global.user().USR_CodigoUsuario
        }

        this.requestService.cancelRequest(cancelRequestData).subscribe({
            next: () => {
                this.global.router.navigate(['/requests/canceled'])
            }
        })
    }

    updateDescription() {
        if (this.selectedType == 'Outros') {
            this.entity.correctionInfo.SOLC_Descricao = '';
            this.isDescriptionDisabled = false;
        }
        else {
            this.entity.correctionInfo.SOLC_Descricao = this.selectedType;
            this.isDescriptionDisabled = true;
        }
    }

    public organizationRequerimentoRule(type: string, org: string) {
        return type == 'REQUERIMENTO' && this.documentCloudflareUrl ? 'SIGN' : org;
    }

    updateMessage() {
        if (this.selectedCancellation === 'outros') {
            this.reasonCancel = '';
            this.textAreaDisabled = false;
        } else {
            const selectReason = this.reasons.find(reason => reason.value === this.selectedCancellation);
            this.reasonCancel = selectReason ? `${this.reasonMessage} ${selectReason.label}` : '';
            this.textAreaDisabled = true;
        }
    }

    public get canFixDocuments(): boolean {
        return this.request.SOL_CodigoSolicitante == this.global.user().PE_CodigoPessoa ||
            (this.userService.isTriagem() && this.request.createdByGroup === 'TRIAGEM')
    }

    groupDocumentsByType(): void {
        const requerimentoDocs = this.request.documentos.requerimento;

        this.groupedDocuments = {};
        this.uniqueDocumentTypes = [];

        for (const doc of requerimentoDocs) {
            if (!this.groupedDocuments[doc.SOLA_Tipo]) {
                this.groupedDocuments[doc.SOLA_Tipo] = [];
                this.uniqueDocumentTypes.push(doc.SOLA_Tipo);
            }
            this.groupedDocuments[doc.SOLA_Tipo].push(doc);
        }
    }

    loadAndGeneratePDF() {
        this.isLoading = true;

        this.historicService.listAll(`"SOLH_CodigoSolicitacao" = ${this.request.SOL_CodigoSolicitacao}`).subscribe({
            next: async (response: any) => {
                this.correctionService.listAll(`"SOLC_CodigoSolicitacao" = ${this.request.SOL_CodigoSolicitacao}`).subscribe({
                    next: async (correctionsResponse: any) => {
                        const fullRequest = {
                            ...this.request,
                            historicos: response.data,
                            consideracoes: correctionsResponse.data
                        };

                        try {
                            const listBlob = await this.requestService.generateFullRequestPDF(fullRequest);

                            const normalizedRequestNumber = `${this.request.SOL_NumeroSolicitacao}`.replace(/[.\-]/g, '');

                            const idDownload = this.globalStateService.addDownload({
                                name: "Solicitação N°" + this.request.SOL_NumeroSolicitacao,
                                type: 0,
                                percent: 0
                            });

                            this.requestService.mergedDocumentInPdf(
                                listBlob,
                                this.request.SOL_CodigoSolicitacao,
                                normalizedRequestNumber,
                                this.request.OR_Sigla
                            ).subscribe((event: HttpEvent<any>) => {
                                this.globalStateService.getEventsRequest(event, idDownload);
                                if (event.type === HttpEventType.Response && event.body instanceof Blob) {
                                    this.global.saveFile(event.body, `Solicitação N° - ${this.request.SOL_NumeroSolicitacao}.pdf`);
                                    this.isLoading = false;
                                }
                            });
                        } catch (err) {
                            this.isLoading = false;
                            Swal.fire('Erro', 'Erro ao gerar o PDF da solicitação.', 'error');
                        }
                    },
                    error: () => {
                        this.isLoading = false;
                        Swal.fire('Erro', 'Não foi possível carregar as considerações.', 'error');
                    }
                });
            },
            error: () => {
                this.isLoading = false;
                Swal.fire('Erro', 'Não foi possível carregar os históricos.', 'error');
            }
        });
    }


    toggleAllCorrections(): void {
        this.allExpanded = !this.allExpanded;
    }

    get filteredSubjects(): ISubject[] {
        if (!this.subjectSearch) return this.subjects;
        const term = this.subjectSearch.toLowerCase();
        return this.subjects.filter(s => s.AS_Descricao.toLowerCase().includes(term));
    }

    openUpdateSubjectModal(): void {
        this.subjectSearch = '';
        this.selectedSubjectCode = null;
        this.selectedSubjectDescricao = '';

        this.subjectService.listAll(`"AS_CodigoOrgao" = ${this.request.SOL_CodigoOrgao} AND "AS_Status" = true AND ("AS_TipoProcesso" = 2 OR "AS_TipoProcesso" = 1)`, 0).subscribe({
            next: (response: any) => {
                this.subjects = response.data;
                this.global.showModalInfo(`${this.modalName}-update-subject`);
            },
        });
    }

    confirmUpdateSubject(): void {
        if (!this.selectedSubjectCode) return;

        const subject = this.subjects.find(s => s.AS_CodigoAssunto === +this.selectedSubjectCode);

        this.requestService.updateSubject(this.request.SOL_CodigoSolicitacao, this.selectedSubjectCode).subscribe({
            next: () => {
                if (subject) this.request.AS_Descricao = subject.AS_Descricao;
                this.global.closeModalInfo(`${this.modalName}-update-subject`);
                this.global.swal.fire('Sucesso', 'Assunto atualizado com sucesso!', 'success');
            },
        });
    }
}
